<template>
  <div id="app">
    <!-- <mqtt></mqtt> -->
    <transition name="slide-fade">
      <router-view v-if="isRouterAlive" />
    </transition>
    <!-- <div class="testWatch hover" @click="watchTest" ref="test">
      实时定位监测
      <div>
        <span>经度：{{ lng }}</span>
      </div>
      <div>
        <span>纬度：{{ lat }}</span>
      </div>
      <div>
        <span>位置：{{ loc }}</span>
      </div>
      <div>
        <span>速度：{{ speed }}</span>
      </div>
      <div>
        <span>精度：{{ accuracy }}</span>
      </div>
      <div>
        <span>海拔精度：{{ altitudeAccuracy }}</span>
      </div>
      <div>
        <dl v-for="item in testlist">
          {{ item.longitude }},{{ item.latitude }}
        </dl>
      </div>
      <div>
        <mu-button color="primary" @click="seeMaps">查看地图</mu-button>
      </div>
    </div> -->
  </div>
</template>

<script>
// import Mqtt from "@/components/mqtt/mqtt";
export default {
  name: "App",
  components: {
    // Mqtt,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      firstBack: null,
      iswatchTest: true,
      lat: window.lat,
      lng: window.lng,
      testlist: [],
      wakeLock: null,
      loc: "",
      accuracy: 0,
      altitudeAccuracy: 0,
      speed: 0,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    seeMaps() {
      this.$router.push({ name: "maps" });
    },
    watchTest() {
      if (this.iswatchTest) {
        this.$refs.test.classList.remove("hover");
      } else {
        this.$refs.test.classList.add("hover");
      }
      this.iswatchTest = !this.iswatchTest;
    },
    backAction() {
      // 监听回退事件
      let _this = this;
      function goExit() {
        if (!_this.firstBack) {
          _this.firstBack = new Date().getTime();
          // 提示
          _this.Toast({
            duration: 1000,
            mask: false,
            message: "再按一次退出程序",
          });
          setTimeout(() => {
            _this.firstBack = null;
          }, 1000);
        } else {
          if (new Date().getTime() - _this.firstBack < 1000) {
            plus.runtime.quit();
          }
        }
      }
      plus.key.addEventListener(
        "backbutton",
        function () {
          if (_this.$route.path === "/home" || _this.$route.path === "/") {
            goExit();
          } else {
            _this.$router.go(-1);
          }
          return false;
        },
        false
      );
    },
    watchGeolocation() {
      // 监听实时定位
      let _this = this;
      plus.geolocation.watchPosition(
        function (p) {
          _this.speed = parseFloat(p.coords.speed);
          _this.lat = p.coords.latitude;
          _this.lng = p.coords.longitude;
          _this.loc = p.addresses;
          _this.accuracy = p.coords.accuracy;
          _this.altitudeAccuracy = p.coords.altitudeAccuracy;

          // console.log("App.vue -> 监控中：", JSON.stringify(p));
          // alert("App.vue -> 监控中：" + JSON.stringify(p));

          _this.$store.commit("setGeolocation", {
            latitude: p.coords.latitude,
            longitude: p.coords.longitude,
            speed: p.coords.speed,
            accuracy: p.coords.accuracy,
            altitudeAccuracy: p.coords.altitudeAccuracy,
            addresses: p.addresses,
          });

          // 坐标转换
          // plus.maps.Map.convertCoordinates(new plus.maps.Point(p.coords.longitude, p.coords.latitude), {}, function(event){
          //   var point = event.coord;  // 转换后的坐标值
          //   _this.lat = point.latitude;
          //   _this.lng = point.longitude;
          //   _this.$store.commit('setGeolocation', {
          //     latitude: point.latitude,
          //     longitude: point.longitude,
          //     speed: p.coords.speed
          //   })
          // },function(e){
          //   alert("Failed:"+JSON.stringify(e));
          // });
        },
        function (e) {
          console.log("定位错误: " + JSON.stringify(e));
          alert("定位错误: " + e.message);
        },
        {
          // coordsType: "wgs84",
          enableHighAccuracy: true,
          geocode: true,
          provider: "system",
        }
      );
    },
    setKeepAlive(keepAlive) {
      if (this.wakeLock) {
        if (keepAlive) {
          this.wakeLock.acquire();
        } else {
          this.wakeLock.release();
        }
      }
      console.log(this.wakeLock.isHeld());
    },
    createWakeLock() {
      console.log("getLock start");
      let main = plus.android.runtimeMainActivity();
      var BluetoothManager = plus.android.importClass(
        "android.os.PowerManager"
      );
      let pw = main.getSystemService("power");
      this.wakeLock = pw.newWakeLock(1, plus.runtime.appid + "_lock");
      this.wakeLock.setReferenceCounted(false);
      console.log("getLock end");
    },
  },
  mounted() {
    let _this = this;
    document.addEventListener("plusready", function () {
      _this.backAction();
      _this.watchGeolocation();
      plus.device.setWakelock(true); // 设置屏幕常亮
      _this.createWakeLock(); // 创建锁
      _this.setKeepAlive(true); // 设置锁为true
    });
  },
};
</script>

<style>
/* 路由动画三种 */
* {
  margin: 0;
  padding: 0;
}

.maintenance-btn.auto-width.fixed {
  width: auto;
  margin: 20px auto;
}

.slide-fade {
  position: absolute;
  left: 0;
  right: 0;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(2, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  left: 0;
  right: 0;
  transform: scale(0.9);
  opacity: 0;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

/* #app .mu-table th, #app .mu-table td{
  padding-left: 5px;
  padding-right: 5px;
  line-height: 28px;
  height: auto;
} */
.mu-demo-form .mu-form-item-content {
  justify-content: center;
}

.mu-input-help {
  color: red;
}

.flex-header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 9999;
}

.content-box {
  width: 100%;
  padding: 45px 0 0;
}

.home .content-box {
  padding-top: 5px;
}

/*下拉选择器*/
.mu-bottom-sheet {
  /* height: 384px;
  overflow-x: hidden;
  overflow-y: scroll; */
}

ul.mu-list {
  max-height: 70%;
  padding: 0;
  overflow: scroll;
}

.mu-item {
  min-height: 48px;
  height: auto;
  border-bottom: 1px dashed #eee;
}

.mu-item-sub-title,
.mu-item-title {
  white-space: inherit;
  height: auto;
}

.mu-switch-checked .mu-switch-thumb {
  -webkit-transform: translate3d(25px, 0, 0);
  transform: translate3d(25px, 0, 0);
}

.mu-switch-container {
  width: 50px;
}

.mu-switch-track {
  height: 20px;
}

.mu-switch-thumb {
  width: 26px;
  height: 26px;
}

.van-toast {
  font-size: 14px;
  line-height: 1.48;
}

div.van-toast--default {
  width: auto;
  min-width: 120px;
}

.testWatch {
  position: fixed;
  right: 0;
  z-index: 999;
  overflow: auto;
  bottom: 10%;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  width: 250px;
  padding: 10px;
  text-align: right;
}

.testWatch.hover {
  right: -235px;
}

.targetLocation {
  position: fixed;
  top: 10%;
  right: -135px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  padding: 10px;
  text-align: right;
  padding-left: 25px;
  width: 150px;
  overflow: auto;
}

.targetLocation.hover {
  right: 0;
}

.my-cards {
  margin: 1rem auto 0;
  max-width: 375px;
}

#mytables .mu-table th,
#mytables .mu-table td {
  padding-left: 5px;
  padding-right: 5px;
}

/**
新增登录页面 样式调整
*/
.login .mu-form-item {
  color: aliceblue;
}

.login .mu-form-item__focus {
  color: #2196f3;
}

.login .mu-form-item__error {
  color: #f44336;
}

.login .mu-text-field-input {
  color: aliceblue;
}

.login .mu-input-line {
  background-color: rgba(255, 255, 255, 0.12);
}

.login .mu-checkbox-label {
  color: aliceblue;
}

/*点检搜索*/
.spotchecksearch .mu-item {
  padding: 2px;
  background: #e9e9e9;
}

.spotchecksearch .mu-item .mu-input {
  padding: 0;
  margin: 0;
  width: 90%;
  min-height: auto;
}

.library-position {
  display: inline-block;
}

.library-position .mu-text-field-input {
  color: red;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
}

.otherMaintenance .mu-dialog-body {
  height: 100%;
}

.auto-width-s {
  width: 100%;
  margin: 0;
  padding: 0;
  min-height: auto;
}

.maintenance-btn {
  display: flex;
  margin: 20px 0 0;
  justify-content: space-between;
  flex-wrap: wrap;
}

.maintenance-btn button {
  margin: 10px 0;
}

.fixed {
  margin: 20px auto;
  /* position: fixed;
  bottom: 20px;
  left: 5%;
  right: 5%; */
}

#app .mu-table-empty {
  height: 100px;
}

.flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.flex .ft {
  width: 45%;
}

.my-card .col {
  margin: 2.5px 0;
}

.photos {
  display: flex;
  padding: 10px;
}

.photos .imgs {
  width: 20%;
  margin: 10px 2.5%;
}

.photos .imgs img {
  width: 100%;
  height: 75px;
}

.grid-cell {
  width: 100%;
  overflow: hidden;
}

#app .mu-checkbox-wrapper {
  height: auto;
  min-height: 24px;
}

#app .mu-checkbox-icon-uncheck {
  color: #e9e9e9;
}

#app {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

#app .task .mu-table th,
#app .task .mu-table td {
  padding-left: 5px;
  padding-right: 5px;
}

body .mu-carousel-item>img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue